import CrudModel from './CrudModel';
export default class CampaignMarketingModel extends CrudModel {
    constructor(entity) {
        super(entity);
    }

    static toCrud({ data }) {
        return data;
    }

    static toList({ data }) {
        return data;
    }
}
